/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const HeatedSeats = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 24 26" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M22.66 19.57a2.44 2.44 0 0 0-2.35-.69c-2.4.25-7.86 1.38-10.81 2a.2.2 0 0 1 0-.08c2-4.47-1.53-9.72-3.24-12.24-.36-.53-.64-.95-.76-1.18a3.8 3.8 0 0 0-1.91-2.2.62.62 0 0 1 0-.77.41.41 0 0 0 .19-.18c.056-.105.1-.215.13-.33.09-.5-1.27-2.79-1.27-2.79A2 2 0 0 0 .19.79C-.11 1.16 2 7.57 2 7.57L4.87 20a2.09 2.09 0 0 0-.21 1.57l1.23 3.83a.44.44 0 0 0 .41.29h15a.42.42 0 0 0 .4-.29l.86-2.58v-.06c.26-.57.87-2.19.1-3.19zM17.48 9.89a.64.64 0 0 0 0 .91.61.61 0 0 0 .46.2.65.65 0 0 0 .46-.2 3.64 3.64 0 0 0 1.2-3.55 4.57 4.57 0 0 0-1.2-2 3.22 3.22 0 0 1-.88-1.48 2.48 2.48 0 0 1 .88-2.29.64.64 0 0 0 .19-.48.61.61 0 0 0-.2-.45.63.63 0 0 0-.91 0 3.67 3.67 0 0 0 0 5.59 2.39 2.39 0 0 1 0 3.75zM21.62 6.12a2.39 2.39 0 0 1 0 3.77.66.66 0 0 0 .46 1.11.63.63 0 0 0 .46-.2 3.64 3.64 0 0 0 1.2-3.55 4.48 4.48 0 0 0-1.2-2 2.39 2.39 0 0 1 0-3.77.65.65 0 0 0-.92-.91 3.64 3.64 0 0 0-1.2 3.55 4.57 4.57 0 0 0 1.2 2zM13.33 6.12a2.39 2.39 0 0 1 0 3.77.66.66 0 0 0 .46 1.11.63.63 0 0 0 .46-.2 3.64 3.64 0 0 0 1.2-3.55 4.48 4.48 0 0 0-1.2-2 2.39 2.39 0 0 1 0-3.77.65.65 0 0 0-.92-.91 3.64 3.64 0 0 0-1.2 3.55 4.57 4.57 0 0 0 1.2 2z" /></g>
      </g>
    </svg>
  </span>
);

HeatedSeats.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

HeatedSeats.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default HeatedSeats;
